import { Component } from '@angular/core';

@Component({
  selector: 'app-status',
  templateUrl: './status-item.component.html',
  styleUrls: ['./status-item.component.scss'],
  standalone: false,
})
export class StatusItemComponent {}
